export default __webpack_public_path__ + "/src/assets/images/ec3-tooltip-v2.png";